<template>
  <div class="computer-main">
    <Header :isShows='shows'></Header>
    <div class="mains">
      <div class="title">
        {{ libDatas.ResouceName }}
      </div>
      <div class="vip" v-if="libDatas.Price == 1">认证会员专享</div>
      <div class="name">
        <van-icon name="contact" />
        <span>{{ libDatas.CreateName }}</span>
      </div>
      <div class="bottom">
        <div>
          <van-icon name="clock-o" />
          <span> {{ libDatas.CreateTime }}</span>
        </div>
        <div>
          <van-icon name="eye-o" /> <span>{{ libDatas.SeeNumber }}</span>
        </div>
        <div>
          <van-icon name="ellipsis" @click="showShare = true" />
          <span>分享</span>
        </div>
        <div v-if="libDatas.IsStore == 0" @click="collection(0)">
          <van-icon name="like-o" color="orange" /> <span>收藏</span>
        </div>
        <div v-if="libDatas.IsStore == 1" @click="collection(1)">
          <van-icon name="like" color="orange" /> <span>取消收藏</span>
        </div>
      </div>
    </div>
    <div class="library">
      <div
        class="pdfs"
        v-if="
          libDatas.FileType == '.ppt' ||
          libDatas.FileType == '.pdf' ||
          libDatas.FileType == '.pptx'
        "
      >
        <img
          :src="urls + item"
          alt=""
          v-for="(item, index) in imglist"
          :key="index"
        />
      </div>
      <iframe
        :src="ResouceUrlHtml"
        frameborder="0"
        width="100%"
        height="100%"
      ></iframe>
    </div>
    <div class="introduction">
      <div class="titles">资源简介：</div>
      <div class="mains" v-html="libDatas.Describe"></div>
    </div>
    <van-share-sheet
      v-model="showShare"
      title="立即分享给好友"
      :options="options"
      @select="onSelect"
    />
    <div class="mask" v-if="isShow" @click.stop="isShow = false">
      <img
        :src="urls + libDatas.MobileUrl"
        class="QRcode"
        alt=""
        v-if="isShow"
      />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import caseApi from "@/api/caseApi";
import url from "@/api/config";
export default {
  name: "computer",
  components: {
    Header,
  },
  data() {
    return {
      shows:false,
      imglist: [],
      id: "",
      libDatas: {},
      urls: url,
      ResouceUrlHtml: "",
      showShare: false,
      options: [
        { name: "微信", icon: "wechat" },
        // { name: "QQ", icon: "qq" },
      ],
      isShow: false,
    };
  },
  created() {
    this.id = this.$route.query.ids;
    let token = localStorage.getItem("token");
    if (!token) {
      this.$toast("未登录,将前往登录页");
      this.$router.push({ path: "/login" });
      return;
    }
    this.getDetail();
  },
  methods: {
    getDetail() {
      caseApi
        .detail({ resid: this.id })
        .then((res) => {
          this.libDatas = res.Data;
          this.libDatas.CreateTime = res.Data.CreateTime.replace("T", " ");
          if (res.Data.FileType == ".mp4") {
            this.fileimg = "image/VIDEO.png";
            this.ResouceUrlHtml = url + res.Data.ResouceUrl;
          } else if (
            res.Data.FileType == ".xls" ||
            res.Data.FileType == ".xlsx"
          ) {
            this.fileimg = "image/EXCEL.png";
            this.getexcel(res.Data.ResouceUrl);
          } else if (res.Data.FileType == ".txt") {
            this.fileimg = "image/TXT.png";
            this.ResouceUrlHtml = url + res.Data.ResouceUrl;
          } else if (
            res.Data.FileType == ".ppt" ||
            res.Data.FileType == ".pptx"
          ) {
            this.fileimg = "image/PPT.png";
            this.getppt(res.Data.ResouceUrl);
          } else if (
            res.Data.FileType == ".doc" ||
            res.Data.FileType == ".docx"
          ) {
            this.fileimg = "image/WORD.png";
            this.getword(res.Data.ResouceUrl);
          } else if (res.Data.FileType == ".pdf") {
            this.fileimg = "image/PDF.png";
            // this.ResouceUrlHtml = url + res.Data.ResouceUrl;
            this.getpdf(res.Data.ResouceUrl, res.Data.ResouceName);
          }
        })
        .catch((error) => {
          if(error.response.status == 401){
             this.$toast("登录超时,请重新登录");
            this.$router.push({ path: "/login" });
          }
        });
    },
    getexcel(path) {
      caseApi.excel({ path }).then((res) => {
        this.ResouceUrlHtml = url + "" + res.LogMessage;
      });
    },
    getword(path) {
      caseApi.word({ path }).then((res) => {
        this.ResouceUrlHtml = url + res.LogMessage;
      });
    },
    getppt(path) {
      caseApi.ppt({ path }).then((res) => {
        // this.ResouceUrlHtml = url + "" + res.LogMessage;
        this.getpdf(res.LogMessage, this.libDatas.ResouceName);
      });
    },
    getpdf(paths, name) {
      caseApi.pdf({ path: paths, resname: name }).then((res) => {
        this.imglist = res.Data;
      });
    },
    // 收藏
    collection(codeType) {
      caseApi
        .SetStore({
          resid: this.id,
          type: codeType,
        })
        .then((res) => {
          if (codeType == 0) {
            this.libDatas.IsStore = 1;
          } else {
            this.libDatas.IsStore = 0;
          }
        });
    },
    onSelect(options) {
      // if (options.name == "QQ") {
      //   let url = window.location.href;
      //   let title = this.libDatas.ResouceName;
      //   let _shareUrl =
      //     "https://connect.qq.com/widget/shareqq/iframe_index.html?";
      //   _shareUrl += "url=" + encodeURIComponent(url || location.href);
      //   _shareUrl += "&title=" + encodeURIComponent(title || document.title);
      //   window.open(_shareUrl, "_blank");
      // } else {
      this.isShow = true;
      this.showShare = false;
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.mains {
  text-align: left;
  padding: 15px 15px;
  .title {
    font-size: 20px;
  }
  .vip {
    width: 23%;
    text-align: center;
    line-height: 22px;
    color: #fff;
    background: #f5c920;
    border-radius: 5px;
  }
  .name {
    padding-top: 10px;
    color: #aaa;
    display: flex;
    align-items: center;
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;
    color: #aaa;
    div {
      overflow: hidden;
      height: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        display: inline-block;
        margin-left: 4px;
      }
    }
  }
}
.library {
  height: 340px;
  .pdfs {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    img {
      width: 100%;
    }
  }
}
.introduction {
  // position: fixed;
  // left: 0;
  // bottom: 0;
  margin-top: 20px;
  padding: 0 15px;
  text-align: left;
  .titles {
    font-size: 20px;
    line-height: 2;
  }
  .mains {
    // text-indent: 2em;
  }
}
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
}
.QRcode {
  position: fixed;
  top: 220px;
  left: 20%;
  width: 60%;
}
</style>
